import { useTranslation } from 'react-i18next';

interface WrongHostProps {
  expected: string;
}

export function WrongHost({ expected }: WrongHostProps): JSX.Element {
  const { t } = useTranslation('common');
  const protocol = typeof window !== 'undefined' ? window.location.protocol : 'http:';
  return (
    <div className="flex h-full items-center justify-center bg-background p-8 text-foreground">
      <div className="max-w-md space-y-3 rounded-lg border border-border bg-card p-6 shadow-sm">
        <h1 className="text-2xl font-semibold">{t('wrongHost.title')}</h1>
        <p className="text-muted-foreground">{t('wrongHost.tenant_body')}</p>
        <p>
          <a
            href={`${protocol}//${expected}`}
            className="font-medium text-primary underline-offset-4 hover:underline"
          >
            {t('wrongHost.open_link', { host: expected })}
          </a>
        </p>
      </div>
    </div>
  );
}
